module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/intro.json
// module id = 359
// module chunks = 264533715932505